"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.promotionsRepositoryMethods = void 0;
const repository_types_1 = require("./repository.types");
exports.promotionsRepositoryMethods = (0, repository_types_1.generateRepositoryMethods)({
    getActivePromotion: {
        callMethod: 'GET',
        endpoint: '/patient/promotion/active',
    },
    checkPromotionValid: {
        callMethod: 'GET',
        endpoint: '/promotions/check-valid',
    },
});
//# sourceMappingURL=promotions.methods.js.map